import React from 'react';
import {CircularProgress} from "@material-ui/core";
import axios from 'axios';
import TextField from "@material-ui/core/TextField";
import {Button} from "@material-ui/core";
import {ServiceLocator} from "../../Services/ServiceLocator";
import { v4 as uuid } from 'uuid';
import WorkshopTemplate from "./WorkshopTemplate";
import BomCheckModal from "./BomCheckModal";
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CancelIcon from '@material-ui/icons/Cancel';
import PrintIcon from '@material-ui/icons/Print';

import { AuthenticationService } from "../../Services/AuthenticationService";
import { getNumberInputDisplayValue, parseNumberInputValue } from '../../utils/numberInputUtils';
import { toUtcForStorage } from '../../utils/dateUtils';
let assemblies = [];
let subAssemblies = [];
let assembly;
let subAssembly;

class Package extends React.Component {
    state = {
        loading: true,
        savingLog: false,
        quantity: 0,
        bomCheckModalOpen: false,
        bomChecked: false
    };

    constructor(props) {
        super(props);
        globalProps = props;

        const jwtToken = AuthenticationService.getInstance().getToken();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + jwtToken;
    }

    componentDidMount() {
        this.loadData();
    }

    loadData = () => {
        const self = this;

        self.setState({loading: true});
        Promise.all([self.loadAssemblies(), self.loadSubAssemblies(), self.loadParts()]).then(() => {
            const assemblyId = globalProps.match.params.assemblyId;
            assembly = assemblies.find(x => x.assembly.id === assemblyId);
            subAssembly = subAssemblies.find(x => x.subAssembly.id === assemblyId);
            self.setState({assembly: assembly ? assembly.assembly : null, subAssembly: subAssembly ? subAssembly.subAssembly : null, loading: false});
        });
    };

    loadAssemblies = () => {
        const assemblyService = ServiceLocator.Instance.getAssemblyService();

        return assemblyService.getAllAssembliesExpanded().then((assembliesResult) => {
            assemblies = assembliesResult;
        });
    };

    loadSubAssemblies = () => {
        const assemblyService = ServiceLocator.Instance.getAssemblyService();

        return assemblyService.getAllSubAssembliesExpanded().then((subAssembliesResult) => {
            subAssemblies = subAssembliesResult;
        });
    };

    loadParts = () => {
        const self = this;
        self.setState({loading: true});
        const partService = ServiceLocator.Instance.getPartService();

        return partService.getAllPartsExpanded().then((parts) => {
            parts = parts.sort(function (a, b) {
                if (a.part.partId < b.part.partId) return -1;
                if (a.part.partId > b.part.partId) return 1;
                return 0;
            });
            self.setState({parts});
        });
    };

    handleOpenBomCheck = () => {
        this.setState({
            bomCheckModalOpen: true
        });
    };

    handleCloseBomCheck = () => {
        this.setState({
            bomCheckModalOpen: false
        });
    };

    handleBomCheckComplete = (assemblyId) => {
        this.setState({ 
            bomChecked: true,
            bomCheckModalOpen: false 
        });
        window.$alertSuccess("BOM Check completed successfully!");
    };

    addPackageLog = () => {
        const self = this;
        const parsedQuantity = parseNumberInputValue(this.state.quantity);
        if (parsedQuantity < 1) return window.$alertWarning("You must select or enter a quantity");

        if (!this.state.bomChecked) {
            const confirm = window.confirm("BOM check has not been completed. Are you sure you want to continue?");
            if (!confirm) return;
        }

        self.setState({savingLog: true});
        const payload = {
            id: uuid(),
            assemblyId: this.state.assembly ? this.state.assembly.id : null,
            subAssemblyId: this.state.subAssembly ? this.state.subAssembly.id : null,
            quantity: parsedQuantity,
            logDate: toUtcForStorage(new Date()),
            bomChecked: this.state.bomChecked,
            reason: '',
            userId: AuthenticationService.getInstance().getUserId()
        };
        const assemblyService = ServiceLocator.Instance.getAssemblyService();
        assemblyService.createPackageLog(payload).then(() => {
            window.$alertSuccess("Package log created");
            self.setState({savingLog: false, completed: true});
        });
    };

    openPrintLabels = () => {
        const item = this.state.assembly || this.state.subAssembly;
        const user = AuthenticationService.getInstance().getUser();
        
        let containerHtml = '';
        const parsedQuantity = parseNumberInputValue(this.state.quantity);
        for (let i = 0; i < parsedQuantity; i++) {
            if (i === 0) containerHtml += `<div class='top-gutter'></div>`;

            if (i % 2 === 0) containerHtml += `<div class='left-gutter'></div>`;
            
            // Use full description with dynamic font sizing
            const fullDescription = item.description || "";
            const descriptionLength = fullDescription.length;
            let fontSize = 13; // Default font size

            if (descriptionLength > 100) {
                fontSize = 8;
            } else if (descriptionLength > 80) {
                fontSize = 9;
            } else if (descriptionLength > 60) {
                fontSize = 10;
            } else if (descriptionLength > 40) {
                fontSize = 11;
            } else if (descriptionLength > 20) {
                fontSize = 12;
            }
                
            // Generate unique tag
            const uniqueTag = user.firstName[0].toUpperCase() + user.lastName[0].toUpperCase() + new Date(new Date().setHours(0,0,0,0)).toISOString().slice(0,10).replace(/-/g,"");
            
            const hasInstallVideo = this.state.assembly.installVideoURL && this.state.assembly.installVideoURL.trim() !== "";
        
            containerHtml += `<div class="label-4x2">
                <div class="rev-tag">${this.state.assembly.revision}</div>
                <div class="label-left">
                    <div><img src="https://jxbstorage.blob.core.windows.net/jxbui/JXB%20BW.png" width="160"/></div>
                    <div style="font-weight: 700; font-size: 28px;">${this.state.assembly.assemblyId}</div>
                    <div style="font-size: ${fontSize}px; line-height: 1.2; word-break: break-word; overflow-wrap: break-word;">${fullDescription}</div>
                    <div style="font-size: 17px; font-weight: 1000; margin-top: 3px;">${this.formatWeight(this.state.assembly)}</div>
                </div>
                <div class="label-right">
                    ${hasInstallVideo ? 
                        `<div style="position: relative;">
                            <img src="https://jxbstorage.blob.core.windows.net/jxbui/Install%20Video.png" width="125"/>
                            <img src='https://api.qrserver.com/v1/create-qr-code/?size=500x500&data=${this.state.assembly.installVideoURL}' style="position: absolute; left: 21px; top: 29px; width: 100px; height: 100px;"/>
                        </div>` 
                        : ''
                    }
                </div>
                <div class="unique-tag">${uniqueTag}</div>
            </div>`;

            if (i % 2 === 1 || i === parsedQuantity - 1) containerHtml += `<div class='right-gutter'></div>`;
        }
        
        containerHtml += '<div class=\'bottom-gutter\'></div>';
        
        const win = window.open("", "Title", "toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=yes,resizable=no,width=384,height=1100");
        win.document.body.innerHTML = `<html><head><style>@media print { @page { margin: 0 !important; } body, html { margin: 0 !important; padding: 0 !important; } }.label-left {width: 54%; display: inline-block; font-size: 13px; padding: 0 9px;} .label-right {width: 37%; display: inline-block; font-size: 11px; font-style: italic;} .labels_page {font-family: Montserrat, sans-serif; width: 4in; position: absolute; top: 0; left: 0; .label-4x2 { height: 2in; text-align: center; display: flex; align-items: center; position: relative; } .unique-tag { position: absolute; right: 16px; bottom: 8px; font-size: 10px; font-style: italic; }.rev-tag { position: absolute; width: 14px; height: 14px; left: 13px; bottom: 8px; font-size: 15px; border: 1px solid black; padding: 5px; line-height: 14px; border-radius: 50%; font-weight: 600; }</style></head><body><div id="container" class="labels_page">` + containerHtml + `</div></body></html>`;
        setTimeout(() => {
            win.print();
        }, 2000);
    };

    formatWeight = (assembly) => {
        const pounds = assembly.weightPounds || 0;
        const ounces = assembly.weightOunces || 0;
        
        if (pounds === 0 && ounces === 0) return "";
        if (pounds === 0) return `${ounces} oz`;
        if (ounces === 0) return `${pounds} lbs`;
        return `${pounds} ${pounds === 1 ? 'lb' : 'lbs'} ${ounces} oz`;
    };

    render() {
        const self = this;
        if (this.state.loading) {
            return (
                <WorkshopTemplate>
                    <div className="mobile-container">
                        <CircularProgress/>
                    </div>
                </WorkshopTemplate>
            );
        }

        const assemblyId = globalProps.match.params.assemblyId;

        if (this.state.completed) {
            return (
                <WorkshopTemplate>
                    <div className="mobile-container">
                        <h2>Log complete!</h2>
                        <div style={{marginBottom: 20}}>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={this.openPrintLabels}
                                className="success-button-lg"
                            >
                                <PrintIcon style={{verticalAlign: 'middle', marginRight: '8px'}} /> Print Label(s)
                            </Button>
                        </div>
                        <Button 
                            variant="contained"
                            color="primary"
                            onClick={() => globalProps.history.push(`/search/${assemblyId}`)}
                            className="success-button-lg"
                        >
                            Assembly Home
                        </Button>
                        <br/><br/>
                    </div>
                </WorkshopTemplate>
            );
        }

        const {assembly, subAssembly} = self.state;

        if (!assembly && !subAssembly) {
            return (
                <WorkshopTemplate>
                    <div className="mobile-container">
                        <h2>Invalid URL</h2>
                    </div>
                </WorkshopTemplate>
            );
        }

        return (
            <WorkshopTemplate>
                <div className="mobile-container">
                    {assembly ?
                        <div>
                            <Button 
                                variant="contained"
                                color="primary"
                                onClick={() => globalProps.history.push(`/search/${assembly.id}`)}
                                className="success-button-lg"
                            >
                                Assembly Home
                            </Button>
                            <h2>Packaging<br/>{assembly.assemblyId} rev {assembly.revision}</h2>
                            <div style={{marginTop: -8, marginBottom: 14, color: '#666'}}>
                                {assembly.description || 'No description'}
                            </div>
                        </div>
                        : ""}
                    {subAssembly ?
                        <div>
                            <Button 
                                variant="contained"
                                color="primary"
                                onClick={() => globalProps.history.push(`/search/${subAssembly.id}`)}
                                className="success-button-lg"
                            >
                                Assembly Home
                            </Button>
                            <h2>Packaging<br/>{subAssembly.subAssemblyId} rev {subAssembly.revision}</h2>
                            <div style={{marginTop: -8, marginBottom: 14, color: '#666'}}>
                                {subAssembly.description || 'No description'}
                            </div>
                        </div>
                        : ""}
                    <div style={{marginBottom: 20}}>
                        <button
                            onClick={!this.state.bomChecked ? this.handleOpenBomCheck : undefined}
                            className={`${this.state.bomChecked ? 'bom-green' : 'bom-red'}`}
                            style={{
                                border: 'none',
                                borderRadius: 4,
                                padding: '12px 20px',
                                fontSize: 16,
                                cursor: 'pointer',
                                outline: 'none',
                                margin: 0,
                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                        >
                            <span style={{marginRight: 8, color: 'white !important'}}>BOM CHECK</span>
                            {this.state.bomChecked ? (
                                <CheckCircleIcon style={{ fontSize: 22, verticalAlign: 'middle' }} />
                            ) : (
                                <CancelIcon style={{ fontSize: 22, verticalAlign: 'middle' }} />
                            )}
                        </button>
                    </div>
                    <Button 
                        variant="contained"
                        color="primary"
                        className="success-button-lg quantity-button" 
                        style={{margin: 10}}
                        onClick={(event) => {this.setState({quantity: (parseNumberInputValue(this.state.quantity) + 1).toString()})}}
                    >
                        1
                    </Button>
                    <Button 
                        variant="contained"
                        color="primary"
                        className="success-button-lg quantity-button" 
                        style={{margin: 10}}
                        onClick={(event) => {this.setState({quantity: (parseNumberInputValue(this.state.quantity) + 2).toString()})}}
                    >
                        2
                    </Button>
                    <Button 
                        variant="contained"
                        color="primary"
                        className="success-button-lg quantity-button" 
                        style={{margin: 10}}
                        onClick={(event) => {this.setState({quantity: (parseNumberInputValue(this.state.quantity) + 4).toString()})}}
                    >
                        4
                    </Button>
                    <Button 
                        variant="contained"
                        color="primary"
                        className="success-button-lg quantity-button" 
                        style={{margin: 10}}
                        onClick={(event) => {this.setState({quantity: (parseNumberInputValue(this.state.quantity) + 10).toString()})}}
                    >
                        10
                    </Button>
                    <Button 
                        variant="contained"
                        color="primary"
                        className="success-button-lg quantity-button" 
                        style={{margin: 10}}
                        onClick={(event) => {this.setState({quantity: (parseNumberInputValue(this.state.quantity) + 20).toString()})}}
                    >
                        20
                    </Button>
                    <Button 
                        variant="contained"
                        color="primary"
                        className="success-button-lg quantity-button" 
                        style={{margin: 10}}
                        onClick={(event) => {this.setState({quantity: (parseNumberInputValue(this.state.quantity) + 100).toString()})}}
                    >
                        100
                    </Button>
                    <br /><br />
                    <TextField
                        placeholder="Quantity Packaged"
                        label="Quantity Packaged"
                        variant="outlined" inputProps={{ inputMode: 'numeric' }}
                        onChange={(event) => this.setState({quantity: event.target.value})}
                        value={this.state.quantity || ''}
                    />
                    <br/><br/>
                    {this.state.savingLog === true ?
                        <CircularProgress />
                        :
                        <Button 
                            variant="contained"
                            color="primary"
                            className="success-button-lg"
                            onClick={this.addPackageLog}
                        >
                            Save
                        </Button>
                    }
                    <br/><br/>
                </div>
                <BomCheckModal
                    open={this.state.bomCheckModalOpen}
                    onClose={this.handleCloseBomCheck}
                    assemblyId={assembly ? assembly.id : (subAssembly ? subAssembly.id : '')}
                    onComplete={this.handleBomCheckComplete}
                />
            </WorkshopTemplate>
        );
    }
}

let globalProps;

export default Package;
